import Typography from "@mui/material/Typography";
import { type FC, type ReactNode } from "react";
import { StyledContainer, StyledContentContainer } from "./styled";

type CardWithPlaceholderProps = {
  text: string;
  isActive: boolean;
  placeholder: ReactNode;
  onSelect: () => void;
  isDisabled?: boolean;
};

const CardWithPlaceholder: FC<CardWithPlaceholderProps> = ({
  text,
  isActive,
  placeholder,
  onSelect,
  isDisabled,
}) => {
  return (
    <StyledContainer isDisabled={isDisabled}>
      <StyledContentContainer
        isActive={isActive}
        onClick={() => !isDisabled && onSelect()}
      >
        {placeholder}
      </StyledContentContainer>
      <Typography variant="bodyMRegular">{text}</Typography>
    </StyledContainer>
  );
};

export default CardWithPlaceholder;
